import _objectSpread from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread2";
import _slicedToArray from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _objectWithoutProperties from "E:\\Gamejam\\PacAnimals\\ninjario\\pac-animals\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["containerRef", "style"],
  _excluded2 = ["container"];
import { Primitive as o } from "@radix-ui/react-primitive";
import { useLayoutEffect as t } from "@radix-ui/react-use-layout-effect";
import e from "react-dom";
import * as r from "react";
import l from "@babel/runtime/helpers/esm/extends";
export var Portal = /*#__PURE__*/r.forwardRef(function (a, i) {
  var n, d;
  var s = a.containerRef,
    u = a.style,
    c = _objectWithoutProperties(a, _excluded),
    m = null !== (n = null == s ? void 0 : s.current) && void 0 !== n ? n : null === globalThis || void 0 === globalThis || null === (d = globalThis.document) || void 0 === d ? void 0 : d.body,
    _r$useState = r.useState({}),
    _r$useState2 = _slicedToArray(_r$useState, 2),
    f = _r$useState2[1];
  return t(function () {
    f({});
  }, []), m ? /*#__PURE__*/e.createPortal( /*#__PURE__*/r.createElement(o.div, l({
    "data-radix-portal": ""
  }, c, {
    ref: i,
    style: m === document.body ? _objectSpread({
      position: "absolute",
      top: 0,
      left: 0,
      zIndex: 2147483647
    }, u) : void 0
  })), m) : null;
}); /*#__PURE__*/
export var UnstablePortal = /*#__PURE__*/r.forwardRef(function (t, a) {
  var i;
  var _t$container = t.container,
    n = _t$container === void 0 ? null === globalThis || void 0 === globalThis || null === (i = globalThis.document) || void 0 === i ? void 0 : i.body : _t$container,
    d = _objectWithoutProperties(t, _excluded2);
  return n ? /*#__PURE__*/e.createPortal( /*#__PURE__*/r.createElement(o.div, l({}, d, {
    ref: a
  })), n) : null;
}); /*#__PURE__*/
export var Root = Portal;